<header>
  <div class="sign-out-header">
    <img src="assets/images/app-logo-no-lead.svg" alt="入試正解デジタル" />
  </div>
</header>
